export const enGb = {
  accountName: "Account name",
  accountNumber: "Account number",
  backToAllMandates: "Back to all mandates",
  beneficiary: "Beneficiary",
  bsb: "BSB",
  currency: "Currency",
  description: "Description",
  email: "Email",
  givenMandateCouldNotBeFound:
    "This mandate could not be found. Make sure you are on the correct mode (production/sandbox).",
  legalName: "Legal name",
  mandate: "Mandate",
  mandateDetails: "Mandate details",
  mandateNotFound: "Mandate not found",
  mandates: "Mandates",
  maxPaymentCountPerPeriod: "Max payment count per period",
  name: "Name",
  noMandatePaymentsYet: "You don't have any payments yet",
  notAvailable: "Not available",
  payer: "Payer",
  payId: "PayID®",
  paymentGateway: "Payment Gateway",
  payments: "Payments",
  payTo: "PayTo",
  period: "Period",
  periodAdhoc: "Ad hoc",
  periodDay: "Daily",
  periodMonth: "Monthly",
  periodWeek: "Weekly",
  periodYear: "Yearly",
  reference: "Reference",
  singlePaymentLimitAmount: "Amount per payment",
  singlePaymentLimitMaxAmount: "Max amount per payment",
  status: "Status",
  untilCancelled: "Until cancelled",
  validityFrom: "Valid from",
  validityTo: "Valid to",
  voltCustomerId: "Volt customer ID",
  voltMandateId: "Volt mandate ID",
} as const;
